import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app";
import reportWebVitals from "./report_web_vitals";
import QueryClientProviders from "./query_client_provider";
import { initAll, setUserId } from "@amplitude/unified";

// Read the runtime value injected into the HTML before nginx starts.
const amplitudeKey = document.querySelector('meta[name="amplitude-api-key"]')?.content;
if (!amplitudeKey) {
  console.error("[amplitude] AMPLITUDE_API_KEY is not set — no events will be sent");
} else {
  initAll(amplitudeKey, {
    serverZone: "EU",
    // Only explicitly named events (see scripts/amplitude_utils.js) are tracked; no unnamed autocaptured events.
    // Sessions stay on because session replay needs them.
    analytics: {
      autocapture: {
        pageViews: false,
        elementInteractions: false,
        formInteractions: false,
        fileDownloads: false,
      },
    },
    sessionReplay: { sampleRate: 1 },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProviders>
      <App />
    </QueryClientProviders>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example, reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
